(function ($)
{
    let cStoryListObjectCounter = 0;

    $.widget("ui.StoryList",
        {
            options:
            {
                ContentBlockSource: null,
                ContentBlockId: null,
                SubscribeUrl: null,
                PaginationMode: 'LoadMoreStyle',
                RotatePages: false,
                RotateAuto: false,
                RotateSpeed: 8000,
                RotatePauseOnHover: true,
                RotateTransitionSpeed: 2000,//possibly useless.
                RotateActiveClass: 'fbcms_activestory',
                StoryResultSelector: '.story_list_result.story',
                ResultListSelector: '.story_list',
                StoryGallerySelector: '.story_gallery',
                MoreSelector: '.story_list',
                LinkedStoryClass: 'fbcms_linkedstory'
            },

            RotatorActive: false,
            RotatorTimer: null,
            RotatorStartTime: null,
            RotatorSpentTime: 0,
            RotatorHasTraversedPage: false,

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _MyObjectNumber: null,

            _create: function ()
            {
                const self = this;

                if (self.options.ContentBlockId === null)
                {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedStoryClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.StoryGallerySelector))
                {
                    FBUtilities.LogMessage('StoryList - required settings null or empty.');
                    return;
                }

                self._MyObjectNumber = cStoryListObjectCounter++;

                const jContainer = $(self.element).find(self.options.ResultListSelector);
                jContainer.attr('role', 'region');
                jContainer.attr('aria-live', 'polite');
                jContainer.attr('id', `StoryListResult${self._MyObjectNumber}`);

                self._setupStoryButtons();
                $(self.element)
                    .find(self.options.StoryGallerySelector)
                    .on('click keydown', self.options.StoryResultSelector, (event) => self._handleStoryResultSelect(event));

                $('.fbcms_story_block').attr('role', 'region').attr('aria-live', 'polite');

                // Setup RSS Buttons.
                $(self.element).on(
                    'click',
                    '.stories_rsssubscribe',
                    function (aEvent)
                    {
                        aEvent.preventDefault();
                        self._showRssPopup(self.element);
                        return false;
                    }
                );

                // Setup Pagination.
                const jGallery = $(self.element).find(self.options.StoryGallerySelector);
                const jMore = jGallery.find(self.options.MoreSelector);

                // ??
                // $gallery.find('#' + `StoryListResult${self._MyObjectNumber}`).append($(data).find(self.options.StoryResultSelector));

                $(self.element).AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Stories/List/${self.options.ContentBlockSource}-${self.options.ContentBlockId}/`,
                        LoadingTitle: "Stories",
                        NormalContainer: jGallery,
                        MoreContainer: jMore,
                        OnSuccess: function (mode, data, _textStatus, _jqXHR)
                        {
                            self._setupStoryButtons();
                        },
                        LiveRegionId: `StoryListResult${self._MyObjectNumber}`
                    });


                // setup video resizer.

                VideoUtilities.SetupVideoResizer('.storymedia_video');

                // setup rotator.

                self.RotatorActive = false;

                if (self.options.PaginationMode === 'FeedStyle')
                {
                    // no rotator activity allowed!
                    return true;
                }

                if (self.options.RotatePages !== true)
                {
                    // nothing to setup.
                    return true;
                }

                if (FBUtilities.IsParameterUndefinedOrNull(self.options.RotateAuto)
                    || FBUtilities.IsParameterUndefinedOrNull(self.options.RotateSpeed)
                    || FBUtilities.IsParameterUndefinedOrNull(self.options.RotatePauseOnHover)
                    || FBUtilities.IsParameterUndefinedOrNull(self.options.RotateTransitionSpeed)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.RotateActiveClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.StoryResultSelector))
                {
                    FBUtilities.LogMessage('StoryList - required settings null or empty.');
                    return false;
                }

                self.RotatorActive = true;

                if (self.options.RotatePauseOnHover === true)
                {
                    $(self.element).hover(() => self._stopRotatorCallback(), () => self._startRotatorCallback());
                }
                self._clearRotatorTime();
                if (self.options.RotateAuto === true)
                {
                    self._nextStory();
                }
            },

            _nextStory: function ()
            {
                const jElement = $(this.element);
                if (this.RotatorActive !== true)
                {
                    return;
                }

                // check # results > 0
                const jContainer = jElement.find(this.options.ResultListSelector);

                const jCurrent = jContainer.find(this.options.StoryResultSelector + '.' + this.options.RotateActiveClass);
                let jNext = null;
                if (jCurrent.length === 1)
                {
                    jNext = jCurrent.next(this.options.StoryResultSelector);
                }

                if (jNext === null || jNext.length === 0 && this.RotatorHasTraversedPage !== true)
                {
                    jNext = jContainer.find(this.options.StoryResultSelector).first();
                }
                else if (jNext === null || jNext.length === 0)
                {
                    jElement.AjaxContentPagination('NextPage', true);
                    return;
                }

                jContainer.find(this.options.StoryResultSelector).removeClass(this.options.RotateActiveClass);
                jNext.addClass(this.options.RotateActiveClass);
                this.RotatorHasTraversedPage = true;
                this._stopRotatorCallback();
                this._startRotatorCallback();
            },

            _stopRotatorCallback: function ()
            {
                if (this.RotatorActive !== true)
                {
                    this._clearRotatorTime();
                }
                else if (this.RotatorTimer !== null)
                {
                    this.RotatorSpentTime = 0;
                    if (this.RotatorStartTime !== null)
                    {
                        this.RotatorSpentTime = Date.now() - this.RotatorStartTime;
                        this.RotatorStartTime = null;
                    }
                    $.clearTimer(this.RotatorTimer);
                }
            },

            _startRotatorCallback: function ()
            {
                if (this.RotatorActive === true)
                {
                    this.RotatorStartTime = Date.now();
                    this.RotatorSpentTime = 0;

                    const self = this;
                    this.RotatorTimer = $.timer(this.options.RotateSpeed, () => self._nextStory());
                }
                else
                {
                    this._clearRotatorTime();
                }
            },
            _clearRotatorTime: function ()
            {
                if (this.RotatorTimer !== null)
                {
                    $.clearTimer(this.RotatorTimer);
                }
                this.RotatorTimer = null;
                this.RotatorStartTime = null;
                this.RotatorSpentTime = 0;
            },

            _showRssPopup: function (element)
            {
                if (FBUtilities.IsStringEmptyOrWhitespace(this.options.SubscribeUrl))
                {
                    return;
                }

                new FBAjaxDialog().Start({
                    AjaxUrl: this.options.SubscribeUrl
                    , ExtraDialogClasses: 'fbd_storiesrss'
                    , LoadingDialogTitle: 'Loading RSS Information'
                    , SuccessDialogTitle: 'RSS Subscription Detail'
                    , ErrorDialogTitle: 'Error Loading RSS Information'
                    , LoadingContent: 'Loading RSS Subscription information.'
                    , ErrorContent: 'Error loading RSS Subscription information.'
                    , SelectionElement: element
                });
            },

            _setupStoryButtons: function ()
            {
                const self = this;
                const jContainer = $(self.element).find(self.options.ResultListSelector);
                const jStories = jContainer.find(self.options.StoryResultSelector);

                $.each(
                    jStories,
                    function (_index, story)
                    {
                        const jStory = $(story);

                        if (jStory.hasClass('story_link') === false)
                        {
                            return;
                        }
                        if (jStory.hasClass(self.options.LinkedStoryClass))
                        {
                            return;
                        }
                        jStory.addClass(self.options.LinkedStoryClass);

                        const jLink = jStory.find('[data-story-id]');
                        if (FBUtilities.IsParameterUndefinedOrNull(jLink.data('href')))
                        {
                            const jControlled = $('.fbcms_story_block');
                            if (jControlled.length > 0)
                            {
                                jLink.attr('aria-controls', jControlled.attr('id'));
                                jControlled.attr('tabindex', '0');
                            }
                        }
                    }
                );
            },

            _handleStoryResultSelect: function (event)
            {
                if (event.type === "keydown"
                    && event.key !== "Enter")
                {
                    return true;
                }

                event.preventDefault();
                const self = this;
                const jStory = $(event.target).closest(self.options.StoryResultSelector);
                if (jStory.hasClass('story_link') === false)
                {
                    return false;
                }
                const jLink = jStory.find('[data-story-id]');
                const storyId = jLink.data('story-id');
                if (FBUtilities.IsParameterUndefinedOrEmpty(storyId))
                {
                    return false;
                }
                const href = jLink.data('href');
                if (FBUtilities.IsParameterUndefinedOrEmpty(href))
                {
                    const jControlled = $('.fbcms_story_block');
                    if (jControlled.length > 0)
                    {
                        jControlled.StoryBlock(
                            'LoadStory',
                            storyId,
                            {
                                OnComplete: function () 
                                {
                                    $(window).scrollTop(jControlled.offset().top);
                                    jControlled.focus();
                                }
                            },
                            self.options.RotateTransitionSpeed
                        );
                    }
                }
                else if (jLink.data('target-new'))
                {
                    window.open(href, "_blank");
                }
                else
                {
                    window.location = href;
                }
                return false;
            }
        });
})(jQuery);
